import { DASHCOLORS } from 'bd-web-components'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1600px; // Aumentado de 1325px para 1600px
  margin: 0 auto;
  padding: 0px 64px;
  height: 100%;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-top: 40px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-top: 27px;
    margin-bottom: 13px;
  }
`

export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 18px;
  }
`

export const FormDivider = styled.div`
  background-color: ${DASHCOLORS.GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-top: 29px;
    margin-bottom: 24px;
  }
`
export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`
export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`
export const CloseButton = styled.button`
  border: none;
  align-self: center;
  justify-self: center;
  background-color: transparent;
  cursor: pointer;
  @media (max-width: 600px) {
    margin-left: 20px;
  }
`

export const ModalContainerTop = styled.div`
  padding-bottom: 25px;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid ${DASHCOLORS.GRAY_SCALE_08};
  margin-bottom: 33px;
`

export const ModalContainerBottom = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: space-between;
  justify-content: space-between;
`

export const Space = styled.div`
  width: 10px;
`

export const ModalTitle = styled.h5`
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
  }
`

export const ModalSubText = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
interface TableContainerProps {
  height: number
  margin: boolean
}

export const TableContainer = styled(styled.div``)<TableContainerProps>`
  width: 100%; // Ocupa toda a largura do Container

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
export const ExceptionContainer = styled(styled.div``)<TableContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`
